export default __webpack_public_path__ + "static/AITracksAtSea-8d8120eb828f2ae2556f9331fa5a9a38.png";